import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { history } from '../sharedHistory';
import GUIDEDSELLING_AI from 'guidedselling-ai';
import GUIDEDSELLING_AI_pckg from '../../node_modules/guidedselling-ai/package.json';

import authentication from './authenticationReducer';
import config from './configReducer';
import language from './languageReducer'
import props from "./propReducer";
import pages from "./pagesReducer";

const GUIDEDSELLING_AI_reduxPerInstance = GUIDEDSELLING_AI_pckg['app-framework'] && GUIDEDSELLING_AI_pckg['app-framework'].reduxPerInstance;

const identityReducer = (state = null, action) => state;

const systemReducers = {
  router: connectRouter(history),
  authentication,
  pages,
  language,
  config,
  props
};

const singleReducer = (reduxPerInstance, reducer) => {
  if(!reducer) return null;
  if(reduxPerInstance) return null;
  return reducer;
};


const perInstanceReducer = (pckg, instanceId, reduxPerInstance, reducer) => {
  if (!reducer) return null;
  if (!reduxPerInstance) return null;
  const changedInstanceId = instanceId.replace(/-/g, '_');
  return (state, action) => {
    if (action.instanceId) {
      if (
        Array.isArray(action.instanceId) &&
        action.instanceId.includes(changedInstanceId)
      ) {
        return reducer(state, action);
      } else if (action.instanceId === changedInstanceId) {
        return reducer(state, action);
      } else {
        return state;
      }
    } else return reducer(state, action, action.instanceId, changedInstanceId);
  };
};


const singleReducersInit = {
  'guidedselling-ai': singleReducer(GUIDEDSELLING_AI_reduxPerInstance, GUIDEDSELLING_AI.reducer),
};

const userReducersPerInstanceInit = {
  'guidedselling-ai': GUIDEDSELLING_AI.reducer && GUIDEDSELLING_AI_reduxPerInstance && combineReducers(Object.fromEntries(Object.entries({
    '699b070cf670b448436534ab': perInstanceReducer('guidedselling-ai', '699b070cf670b448436534ab', GUIDEDSELLING_AI_pckg['app-framework'], GUIDEDSELLING_AI.reducer),
  }).filter(pair => pair[1]))),
};

const userReducersSingle = Object.fromEntries(Object.entries(singleReducersInit).filter(pair => pair[1]));
const userReducersPerInstance = Object.fromEntries(Object.entries(userReducersPerInstanceInit).filter(pair => pair[1]));

export default combineReducers({
  ...systemReducers,
  ...userReducersSingle,
  ...userReducersPerInstance,
});
